import { DEPARTMENTS_URL } from '@/modules/department/department.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';
import { createEmptyComponent } from '@/router/route.service';

export default [
  {
    path: DEPARTMENTS_URL.path,
    redirect: '/',
    beforeEnter: resolveCurrentUser,
    component: { render: createEmptyComponent },
    children: [
      {
        ...DEPARTMENTS_URL.view,
        component: () => import('@/modules/department/views/DepartmentViewPage.vue'),
      },
      {
        ...DEPARTMENTS_URL.edit,
        component: () => import('@/modules/department/views/DepartmentEditPage.vue'),
      },
      {
        ...DEPARTMENTS_URL.forbidden,
        component: () => import('@/modules/department/views/DepartmentForbidden.vue'),
      },
    ],
  },
];

export function goToForbiddenDepartment($router) {
  $router.push({
    name: DEPARTMENTS_URL.forbidden.name,
  });
}

export function goToOpenDepartment($router, department) {
  $router.push({
    name: DEPARTMENTS_URL.view.name,
    params: { id: department.id },
    query: { name: department.slug },
  });
}
